"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var validate_1 = require("../validate");
exports.maxLength = function (max) {
    return function (value) { return value.length > max ? ["Must be less than " + max + " characters"] : validate_1.valid; };
};
exports.minLength = function (min) {
    return function (value) { return value.length < min ? ["Must be at least " + min + " characters"] : validate_1.valid; };
};
exports.validEmail = function (email) {
    var parts = email.split('@');
    var before = parts[0], after = parts[1];
    var isValidEmail = (email.length > 0) &&
        parts.length === 2 &&
        before.length > 0 &&
        after.length > 0;
    return isValidEmail ? validate_1.valid : ['Please enter a valid email'];
};



//////////////////
// WEBPACK FOOTER
// ../composable-validation/dist/validators/text.js
// module id = 37
// module chunks = 0